import type { CheckoutEntryPoint, PremiumFeature } from '@otter-ai/telemetry';
import { atom } from 'jotai';
import type { Step } from './constants';
import { steps } from './constants';

export type CheckoutTracking = {
  premiumFeature: PremiumFeature | null;
  checkoutEntryPoint: CheckoutEntryPoint | null;
};

export const currentStepAtom = atom<Step>(steps.planSelection);
export const billingCycleAtom = atom<'yearly' | 'monthly'>('yearly');
export const checkoutTrackingAtom = atom<CheckoutTracking>({
  premiumFeature: null,
  checkoutEntryPoint: null,
});
